import React from 'react'
import styled, { css } from 'styled-components'

const v4 = css`
  width: unset;
  height: unset;
  padding: unset;
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;

  .text {
    color: unset;
    font-weight: 400;
    font-size: var(--smallText);
    letter-spacing: 0.25px;
    line-height: 22px;
    margin-top: var(--2xs);
  }
`

const Wrapper = styled.a`
  width: 220px;
  height: 183px;
  padding: 15px 10px;
  cursor: pointer;
  background-color: #fff;
  display: inline-block;

  &:hover {
    background-color: #e4e9ef;
  }

  img {
    width: 200px;
    height: 80px;
    margin-bottom: 15px;
  }

  .text {
    color: #000f9f;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    padding: 0 20px;
    text-transform: capitalize;

    &:hover {
      text-decoration: underline;
    }
  }
  @media (max-width: 991px) {
    height: unset;
    && .text {
      padding: 15px 0 0 0;
      color: #313334;
      font-size: 12px;
    }
  }
  ${props => props.version === 'v4' && v4}
`

const SquareLink = ({ title, url, link, version }) => {
  return (
    <Wrapper href={link} version={version}>
      {version !== 'v4' && <img src={url} alt="" className={'hidden-xs hidden-sm icon'} />}
      <div className="text">{title}</div>
    </Wrapper>
  )
}

export default SquareLink



// WEBPACK FOOTER //
// ./src/components/Navbar/components/SquareLink.js